const TextMessage = ({ text }) => {
    return <p className="text-center fs-sm my-3">{text}</p>;
};

export default TextMessage;
